// frontend/src/api/client.js
import axios from 'axios';

// ✅ Base URL is just the domain (no /api)
const API_BASE = import.meta.env.VITE_API_URL || '';

const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Response interceptor
api.interceptors.response.use(
    (response) => response.data,
    (error) => {
        console.error('API Error:', error.response?.data || error.message);
        return Promise.reject(error);
    }
);

// ============= AUTH API =============
export const authAPI = {
    // ✅ Removed /api from endpoints
    checkAuth: () => api.get('/api/login'),
    login: (data) => api.post('/api/login', data),
    logout: () => api.post('/api/logout'),
    
    // Registration Flow
    schoolInfo: (data) => api.post('/api/school-info', data),
    usernameStep: (data) => api.post('/api/username', data),
    selectUsername: (data) => api.post('/api/select-username', data),
    emailVerification: (data) => api.post('/api/email-verification', data),
    studentInfo: (data) => api.post('/api/student-info', data),
    saveAvatar: (data) => api.post('/api/save-avatar', data),
    
    // Password Reset
    forgotPassword: (data) => api.post('/api/forgot-password', data),
    verifyResetCode: (data) => api.post('/api/verify-reset-code', data),
    resetPassword: (data) => api.post('/api/reset-password', data),

};


export const conceptAPI = {
    
    getConceptSelection: () => api.get('/api/concept-selection'),
    getSubconcepts: (conceptId) => api.get(`/api/subconcepts/${conceptId}`),
    updateSubconceptSelection: (data) => api.post('/api/update-subconcept-selection', data),
    saveSubconceptSelections: (selections) => api.post('/api/save-subconcept-selection', { selections }),
    getAdaptiveStatus: () => api.get('/api/adaptive-status'),
    saveConceptSelections: (concepts) => api.post('/api/save-concept-selection', { concepts }),
    getSelectedSubconceptMastery: () => api.get('/api/selected-subconcept-mastery'),
};


export const assessmentAPI = {
    startAssessment: () => api.post('/api/start-real-time-adaptive'),
    submitPerformance: (data) => api.post('/api/update-adaptive-performance', data),
    getNextQuestion: () => api.post('/api/generate-next-adaptive-question'),
    submitAssessment: (data) => api.post('/api/submit-real-time-assessment', data),
    getHistory: () => api.get('/api/assessment-history'),
    getResults: (assessmentId) => api.get(`/api/results/${assessmentId}`),
};

// ============= PRACTICE API =============
export const practiceAPI = {
    generateGamifiedQuestions: (data) => api.post('/api/generate-gamified-questions', data),
    submitPracticeAnswer: (data) => api.post('/api/submit-practice-answer', data),
    savePracticeSession: (data) => api.post('/api/save-practice-session', data),
    getPracticeStats: () => api.get('/api/practice-stats'),
};

// ============= DASHBOARD API =============
export const dashboardAPI = {
    getUserStats: () => api.get('/api/user-stats'),
    getRecentActivity: () => api.get('/api/recent-activity'),
    getSubconceptMastery: () => api.get('/api/selected-subconcept-mastery'),
    getStudentMetrics: () => api.get('/api/student-success-metrics-enhanced'),
    getRankings: () => api.get('/api/subconcept-comprehensive-rankings'),
};

// ============= PROFILE API =============
export const profileAPI = {
    getProfile: () => api.get('/api/profile'),
    updateProfile: (data) => api.post('/api/update-profile', data),
    changePassword: (data) => api.post('/api/change-password', data),
    changeAvatar: (data) => api.post('/api/change-avatar', data),
};

// ============= DAILY ASSESSMENT API =============
export const dailyAPI = {
    checkStatus: () => api.get('/api/daily-assessment/status'),
    generateQuestions: () => api.post('/api/generate-daily-questions'),
    submitAssessment: (data) => api.post('/api/submit-daily-assessment', data),
};

// ============= VIDEO API =============
export const videoAPI = {
    getConceptVideo: (data) => api.post('/api/get-concept-video', data),
};

export default api;